export function HistoryPage() {
  return (
    <div className="gl-page">
      <div style={{ marginBottom: 24 }}>
        <div style={{ fontSize: 20, fontWeight: 600, color: 'var(--gl-text)', letterSpacing: '-0.3px' }}>History</div>
        <div style={{ fontSize: 12, color: 'var(--gl-text-muted)', marginTop: 4 }}>
          Histori keputusan bot — Qorin Hindsight memory
        </div>
      </div>

      <div className="g-card rvl" style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 32, marginBottom: 16, opacity: 0.4 }}>📜</div>
        <div style={{ color: 'var(--gl-text)', fontSize: 15, fontWeight: 500, marginBottom: 8 }}>Decision Timeline</div>
        <div style={{ color: 'var(--gl-text-faint)', fontSize: 13, maxWidth: 400, margin: '0 auto', lineHeight: 1.6 }}>
          Timeline akan muncul setelah Qorin Hindsight integration selesai.
          Saat ini data masih mentah di <span style={{ fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--gl-purple)' }}>tc_bot.candidates</span>.
        </div>
      </div>
    </div>
  );
}